import React from 'react'
import {BillingHeader} from '@/ui/index'

export function OrgBillingChartHeader() {
  return <BillingHeader />
}
